import axios from "axios";

export default class GraficasService {
    
    static getGraficas(id, params) {
        return axios.get( `/api/indicadores/${id}/graficas`, {params} ).catch(err => console.err(err));
    } 

    static testGraficas(params) {
        return axios.post( `/api/test-graficas`, params ).catch(err => console.err(err));
    } 

    static addSeparadores( valor ) {
        if (!valor) return "0";
        let enterosYDecimales = valor.toString().split(".");
        enterosYDecimales[0] = enterosYDecimales[0]
            .split(".")[0]
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return enterosYDecimales.join(",");
    }

    modificarOptions(opciones, optionsGrafica) {
        let arrayOpciones = opciones.split(",");
        arrayOpciones.forEach((opcion) => this.switchOpciones(opcion.trim(), optionsGrafica));
    }

    switchOpciones(opcion, optionsGrafica) {
        switch (opcion) {
            case "eje_y_1k":
                this.addEjeY1k(optionsGrafica);
                break;
            case "eje_y_1m":
                this.addEjeY1m(optionsGrafica);
                break;
            case "eje_y_0":
                this.empezarEjeY0(optionsGrafica);
                break;
            case "eje_y_porcentaje":
                this.ejeYporcentaje(optionsGrafica);
                break;
            case "ocultar_eje_x_par":
                this.ocultarEjeXpar(optionsGrafica);
                break;
            case "ocultar_eje_x_impar":
                this.ocultarEjeXimpar(optionsGrafica);
                break;
            case "ocultar_leyenda":
                this.ocultarLeyenda(optionsGrafica);
                break;
        }
    }

    addEjeY1k(optionsGrafica) {
        optionsGrafica.scales.yAxes[0].ticks = {
            callback: function (label, index, labels) {
                return label != 0 ? label / 1000 + "k" : label;
            },
        };
    }
    addEjeY1m(optionsGrafica) {
        optionsGrafica.scales.yAxes[0].ticks = {
            callback: function (label, index, labels) {
                return label != 0 ? label / 1000000 + "M" : label;
            },
        };
    }
    empezarEjeY0(optionsGrafica) {
        optionsGrafica.scales.yAxes[0].ticks.beginAtZero = true;
    }

    ejeYporcentaje(optionsGrafica) {
        optionsGrafica.scales.yAxes[0].ticks.beginAtZero = true;
        optionsGrafica.scales.yAxes[0].ticks.max = 100;
    }

    ocultarEjeXpar(optionsGrafica) {
        optionsGrafica.scales.xAxes[0].ticks = {
            callback: function (tick, index, array) {
                return index % 2 ? "" : tick;
            },
        };
    }
    ocultarEjeXimpar(optionsGrafica) {
        optionsGrafica.scales.xAxes[0].ticks = {
            callback: function (tick, index, array) {
                return Math.max(0, index-1) % 2 ? "" : tick;
            },
        };
    }
    ocultarLeyenda(optionsGrafica) {
        optionsGrafica.legend = {
            display: false,
        };
    }
}